import React, { useState, useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import { take } from 'lib/array/arrayUtils'

import useMerchandiseCategoriesList from 'hooks/Merchandise/useMerchandiseCategoriesList'

import Sheet from 'components/utils/Sheet'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'

import LoadingBox from 'components/Common/Loading/LoadingBox'
import LayoutContainer from 'components/Common/LayoutContainer'
import OfferListLoadMoreButton from 'components/OfferList/OfferListLoadMoreButton'

import Heading from 'LuxKit/Typography/Heading'

import MerchandiseCategoryGridCard from './MerchandiseCards/MerchandiseCategoryGridCard'

const GridContainer = styled.div`
  display: grid;
  gap: ${rem(20)};
  grid-template-columns: 1fr 1fr;
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

const CardSkeleton = styled(LoadingBox)`
  width: 100%;
  height: ${rem(160)};

  ${mediaQueryUp.tablet} {
    height: ${rem(270)};
  }
`

const PAGE_SIZE = 12

function MerchandiseCategoriesPage() {
  const intl = useIntl()
  const [categoriesList, fetchingList] = useMerchandiseCategoriesList({ sortBy: 'top', level: 0 })
  const [page, setPage] = useState(1)

  const onLoadMore = useCallback(() => {
    setPage(page + 1)
  }, [page])

  const itemCount = page * PAGE_SIZE
  const hasMore = categoriesList.length > itemCount

  return <Sheet padding="40 0">
    <LayoutContainer>
      <Group
        direction="vertical"
        gap={40}
      >
        <Heading variant="heading1">
          {intl.formatMessage({
            id: 'e0QiVV3vwK',
            defaultMessage: 'Shop by Category',
            description: 'Page heading for merchandise categories page',
          })}
        </Heading>

        <GridContainer>
          {fetchingList && <>
            {Array.from({ length: 8 }, (_, i) => (
              <CardSkeleton key={i} />
            ))}
          </>}

          {take(categoriesList, itemCount).map(categoryId => <MerchandiseCategoryGridCard
            key={categoryId}
            id={categoryId}
          />)}
        </GridContainer>

        {hasMore && <Group direction="horizontal" horizontalAlign="center">
          <OfferListLoadMoreButton
            onClick={onLoadMore}
            onScrollNear={onLoadMore}
            showLoadingIndicator
          >
            {intl.formatMessage({
              id: 'BPbfiPMThR',
              defaultMessage: 'Load more',
              description: 'Button text to load more merchandise categories',
            })}
          </OfferListLoadMoreButton>
        </Group>}
      </Group>
    </LayoutContainer>
  </Sheet>
}

export default MerchandiseCategoriesPage
